<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Ceding Broker Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryIntermediaryForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header"><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryIntermediaryForm"
                              v-model="filtersIntermediary.inter"
                              :label="filtersIntermediaryLabel.inter"
                              :error-messages="errors.collect('inter')"
                              data-vv-name="inter"
                              :data-vv-as="filtersIntermediaryLabel.inter"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryIntermediaryForm"
                              v-model="filtersIntermediary.intermediaryName"
                              :label="filtersIntermediaryLabel.intermediaryName"
                              :error-messages="errors.collect('intermediaryName')"
                              data-vv-name="intermediaryName"
                              :data-vv-as="filtersIntermediaryLabel.intermediaryName"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearDeptFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="deDeptFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-card>
            <v-card-text>
              <v-data-table
                v-bind:headers="intermediaryHeaders"
                v-bind:items="intermediaryItems"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItemsIntermediary"
                v-bind:options.sync="paginationIntermediary"
                item-key="inter"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.inter }}</td>
                    <td class="text-xs-left">{{ row.item.name }}</td>
                    <td style="text-align: center">
                      <v-btn text icon color="primary" type="submit" @click.prevent="assignCedBrk(row.item)">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersIntermediaryLabel: {
        inter: 'Intermediary',
        intermediaryName: 'Name'
      },
      filtersIntermediary: {
        inter: undefined,
        intermediaryName: undefined,
        group: undefined,
        interGrps: undefined,
        perDebtTran: undefined
      },
      intermediaryItems: [],
      totalItemsIntermediary: 0,
      intermediaryHeaders: [
        { text: 'Intermediary', align: 'left', value: 'inter' },
        { text: 'Name', value: 'name' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationIntermediary: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  created() {
    this.doClearFilters()
  },
  methods: {
    doClearFilters() {
      this.filtersIntermediary.inter = ''
      this.filtersIntermediary.intermediaryName = ''
      this.filtersIntermediary.group = this.param
      this.filtersIntermediary.interGrps = this.interGrps
      this.filtersIntermediary.perDebtTran = this.perDebtTran
      if (this.cedFields === 'cedBrk') {
        this.fetchIntermediaryBrokerData()
      } else if (this.cedFields === 'cedCo') {
        this.fetchIntermediaryCompanyData()
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryIntermediaryForm').then((result) => {
        if (result) {
          this.paginationIntermediary.page = 1
          this.filtersIntermediary.group = this.param
          this.filtersIntermediary.interGrps = this.interGrps
          if (this.cedFields === 'cedBrk') {
            this.fetchIntermediaryBrokerData()
          } else if (this.cedFields === 'cedCo') {
            this.fetchIntermediaryCompanyData()
          }
        }
      })
    },
    assignCedBrk(data) {
      this.$emit('assign-cedBrk', data)
      this.$emit('close')
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearFilters()
      }
    },
    'paginationIntermediary': function (value) {
      this.filtersIntermediary.interGrps = this.interGrps
      if (this.cedFields === 'cedBrk') {
        this.fetchIntermediaryBrokerData()
      } else if (this.cedFields === 'cedCo') {
        this.fetchIntermediaryCompanyData()
      }
    },
    param: function (value) {
      this.doClearFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, helpListMixin],
  props: {
    param: {
      type: String,
      default: ''
    },
    headerInfo: {
      type: String,
      default: ''
    },
    interGrps: {
      type: String,
      default: undefined
    },
    perDebtTran: {
      type: String,
      default: ''
    },
    menu: Object,
    cedFields: String,
    boolRefresh: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
</style>
